import React from 'react'
import Banner from '../../Common/Banner3'
import img from "../../../Assets/Images/img-platform-banner@3x.png"
import Intro from './Intro'
import Reason from './Reason'
import Instruction from './Instruction'
import PlatformMap from './Map'
import { useNavigate } from "react-router-dom";
import { RoutesString } from "../../Modules/routesString";
import * as Scroll from "react-scroll"
function Platform() {
  const navigation = useNavigate();
  const scroll = Scroll.animateScroll
  return (
    <main>
        <Banner
        img={img}
        title={`更接近顧客滿意的\nCSBYE平`}
        subTitle="實現與顧客的順暢溝通、高服務滿意度、"
        detail={`CSBYE平台是一個利用ADD-UP客戶管理服務訣竅的CRM平台。
        基於網絡，易於訪問，把重點放在了諮詢員的便利性上。
        可應用於各個領域，提供穩定、高效的服務，提高客戶滿意度。`}
        onPressButton={() => {
          scroll.scrollToTop()
          navigation(RoutesString.free_tw);
        }}
        textButton={"免費試用"}
        textButtonn={"平臺手冊"}
        backgroundColor="#162a56"
      />
      <Intro />
      <Reason />
      <Instruction />
      <PlatformMap />
    </main>
  )
}

export default Platform